import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { BinderSetupData } from 'src/app/models/binder/binder-setup-data.model';
import { BinderSessionWizardService } from 'src/app/services/sections/binder/binder-session-wizard.service';

@Injectable({
	providedIn: 'root'
})
export class BinderSessionSetupDataResolver implements Resolve<Observable<BinderSetupData>> {

	constructor(
		private router: Router,
		private binderWizardService: BinderSessionWizardService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;
		GlobalSettingsService.navigationBarActions.clear();
		GlobalSettingsService.isJobCompletedStatusVisible = false;

		return this.binderWizardService
			.getBinderYears(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
